import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useFetalDeathChartsDataContext } from './hooks/useFetalDeathChartsDataContext';

export const Weight = () => {
    const { chartData } = useFetalDeathChartsDataContext();


    return (
        <SimpleBars
            title={'Peso'}
            horizontal={true}
            subtitles={chartData?.weight?.map((item) => item.description)}
            values={chartData?.weight?.map((item) => item.total  ||  0)}
            className='aligned-container'
        />
    );
};
